export type Step = {
  number: string
  title: string
  description: string
}

export const steps: Step[] = [
  {
    number: '01',
    title: 'Consultation',
    description:
      'You meet Dr. Sara directly — never a coordinator. We listen first, review your history and anatomy, and speak candidly about what surgery can and cannot do for you.',
  },
  {
    number: '02',
    title: 'Personalized Plan',
    description:
      'A written plan built around your proportions, recovery window and budget. Technique, timeline, and expected outcome are documented before you commit to anything.',
  },
  {
    number: '03',
    title: 'Treatment & Care',
    description:
      'Your procedure takes place in an accredited surgical suite, followed by structured aftercare — scheduled check-ins, lymphatic support, and direct access to our team.',
  },
]
